import React from "react";

export default function Stepper({ steps, currentStep }) {
  return (
    <div className="d-flex justify-content-between align-items-center">
      {steps.map((step, index) => {
        return (
          <div className="d-flex flex-column align-items-center gap-3">
            <div
              className={`rounded-pill d-flex justify-content-center align-items-center fw-semibold ${
                currentStep === index ? "bg-primary opacity-75" : "opacity-25 "
              }`}
              style={{
                fontSize: "1.2rem",
                width: "3.2rem",
                height: "3.2rem",
                color: currentStep === index ? "whitesmoke" : "",
                border: "1px solid rgba(0, 0, 0, 1)",
                borderRadius: "20rem",
              }}
            >
              {index + 1}
            </div>
            <p
              className="w-100 text-center fw-medium color-primary opacity-75"
              style={{ fontSize: ".8rem" }}
            >
              {step}
            </p>
          </div>
        );
      })}
    </div>
  );
}
